import { useEffect, useRef, useState } from 'react';

function TableLoadingView({ isLoading, rows, columns, withHeader, isVisible }: {
    isLoading: boolean,
    rows: number,
    columns: number,
    withHeader?: boolean,
    isVisible?: boolean
}) {
    const [internalLoading, setInternalLoading] = useState(isLoading);
    const timerRef = useRef<NodeJS.Timeout | null>(null);

    useEffect(() => {
        if (isLoading) {
            setInternalLoading(true);
            if (timerRef.current) {
                clearTimeout(timerRef.current);
            }

            timerRef.current = setTimeout(() => setInternalLoading(false), 2000);
        }
    }, [isLoading]);

    const shouldShow = (internalLoading || isLoading) && (isVisible !== false);

    return (
        <div
            className={`min-w-full inline-block align-middle transition-all duration-300 ease-in-out ${shouldShow
                ? 'opacity-100 max-h-full'
                : 'opacity-0 max-h-0 overflow-hidden'
                }`}
        >
            <table className="min-w-full divide-y divide-border">
                {withHeader && (
                    <thead>
                        <tr className="border-t border-border">
                            <th scope="col" className="px-3 py-2.5 text-start">
                                <div className="h-4 w-4 bg-surface-darker rounded animate-pulse" />
                            </th>
                            {[...Array(columns)].map((_, i) => (
                                <th key={i} scope="col" className="px-5 py-2.5">
                                    <div className="h-4 bg-surface-darker rounded animate-pulse" />
                                </th>
                            ))}
                        </tr>
                    </thead>
                )}
                <tbody className="divide-y divide-border">
                    {[...Array(rows)].map((_, rowIdx) => (
                        <tr key={rowIdx}>
                            <td className="px-3 py-4">
                                <div className="h-4 w-4 bg-surface-darker rounded animate-pulse" />
                            </td>
                            {[...Array(columns)].map((_, colIdx) => (
                                <td key={colIdx} className="px-4 py-3">
                                    <div className="h-4 bg-surface-darker rounded animate-pulse" />
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
}

export default TableLoadingView;